
export function getAutocompleteDomConfig(el) {
  if (!el) {
    return {}
  }
  const dataAutocomplete = el.getAttribute('data-autocomplete') || el.dataset.autocomplet
  const inputAutocompleteNumber = el.getAttribute('data-autocomplete-number') || el.dataset.autocompletNumber
  return {
    inputAutocomplete: dataAutocomplete,
    inputAutocompleteNumber
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/autocomplete-dom.js